import { getCss } from '../dom/get-css';
import { parseCssUnit } from './parse-css-unit';

export function getParsedCssUnit(
	element: Element,
	name: string,
	computed?: CSSStyleDeclaration
): number {
	return parseCssUnit(getCss(element, name, computed));
}
